<div style="max-width: 500px">
  <span class="material-icons close-btn" (click)="dialogRef.close(false)">
    close
  </span>
  <h2 mat-dialog-title class="text-center">Confirmation</h2>
  <mat-divider class="yellow-divider"></mat-divider>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="row text-center">
        <label
          >Will you be ending your shift the next day?
          <br />
          (Select yes if your shift overlaps midnight)</label
        >
        <div class="row">
          <mat-radio-group formControlName="shift_type" style="margin-right: 0">
            <mat-radio-button [value]="'Night'">Yes </mat-radio-button>
            <mat-radio-button [value]="'Day'">No </mat-radio-button>
          </mat-radio-group>
        </div>
        <br />
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      mat-flat-button
      mat-dialog-close
      (click)="onHandleSubmit()"
      [disabled]="form.invalid"
      style="margin-right: 10px"
    >
      SUBMIT
    </button>
    <button
      mat-button
      mat-dialog-close
      class="btn-grey"
      (click)="dialogRef.close(false)"
    >
      CLOSE
    </button>
  </mat-dialog-actions>
</div>
